import React from 'react';
import { Box } from '@mui/material';

interface ScheduleOutlinedIconProps {
  fontSize?: 'small' | 'medium' | 'large' | 'inherit';
  style?: React.CSSProperties;
}

const ScheduleOutlinedIcon: React.FC<ScheduleOutlinedIconProps> = ({ fontSize = 'medium', style }) => {
  const sizes = {
    small: 20,
    medium: 24,
    large: 35,
    inherit: 'inherit',
  };

  const size = sizes[fontSize];
  const fontSizeValue = fontSize === 'small' ? '16px' : fontSize === 'large' ? '28px' : '20px';

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        fontSize: fontSizeValue,
        fontWeight: 600,
        fontFamily: 'Arial, sans-serif',
        lineHeight: 1,
        userSelect: 'none',
        ...style,
      }}
    >
      S
    </Box>
  );
};

export default ScheduleOutlinedIcon;